import { troubleshootSteps } from "@/mocks/homeData";

export default function TroubleshootSection() {
  return (
    <section id="troubleshoot" className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="text-xs font-medium tracking-wide text-primary-600">打不开排查</span>
          <h2 className="mt-2 font-heading font-bold text-xl md:text-3xl text-foreground-950">
            网站打不开？按这五步来处理
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            从网络到缓存的顺序排查，绝大多数「打不开」都能当场定位原因，避免反复刷新浪费时间。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {troubleshootSteps.map((step, index) => (
            <div
              key={step.id}
              className={`bg-background-100 rounded-lg border border-background-200 p-5 flex gap-4 ${
                index === troubleshootSteps.length - 1 ? "md:col-span-2" : ""
              }`}
            >
              <span className="shrink-0 font-heading font-bold text-2xl text-primary-500/70 leading-none w-10">
                {step.step}
              </span>
              <div>
                <h4 className="font-medium text-sm text-foreground-950">{step.title}</h4>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}